export default (props, vars) => !!vars?.['usestateappdetailspopup']?.['state'];
